import deleteObject from '@/handlers/deleteObject';

export default async function (keys, successCallback = e => e, errorCallback = e => e) {
  try {
    // delete file from storage
    const promises = keys.map(key => deleteObject(key));

    // Check if all promises have been fulfilled, and if not, handle errors accordingly
    const results = await Promise.allSettled(promises);
    // Handle any errors that may have occurred individually
    const rejectedPromises = results.filter(result => result.status === 'rejected');
    if (rejectedPromises.length > 0) {
      rejectedPromises.forEach(rejectedPromise => errorCallback(rejectedPromise.reason));
    }

    // Call the success callback after all promises are resolved.
    // This ignores any errors that may have occurred, as long as at
    // least one promise was fulfilled. This is because we would expect
    // a scenario were some files are deleted, but others are not.
    // Regardless if some files could not be deleted, we are still
    // happy that does that could have been.
    //
    // Besides, AWS offers no way to delete multiple files at once,
    // there are no transactions and no rollbacks.
    if (results.length > rejectedPromises.length) {
      successCallback(results);
    }
  } catch (e) {
    errorCallback(e);
  }
}
